import { LOOKING_FOR_OPTIONS } from '../LOOKING_FOR_OPTIONS';
import { LookingForOptionIdType } from '../types';

const DEFAULT_ID: LookingForOptionIdType = 'first_time_trans';
const DEFAULT_TITLE = LOOKING_FOR_OPTIONS[0].title;

export const getLookingForChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): LookingForOptionIdType | null => {
  const id = LOOKING_FOR_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getLookingForChoiceTitleById = (
  id: LookingForOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = LOOKING_FOR_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
